// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1U6_I","upload":"Small_upload__35B-f","imageWrap":"Small_imageWrap__2Op9Z","removeBtn":"Small_removeBtn__247F9"};